import i18n from 'i18next';

i18n.addResources('es', 'Table', {
  noContent: 'No hay datos disponibles'
});
